import GATSBY_COMPILED_MDX from "/app/frontend/content/texts/recommandations.md";
import {graphql} from "gatsby";
import React from "react";
import styled from "styled-components";
import Content from "components/Recommandations";
import Web from "components/layout/Web";
const Introduction = (styled.div)`
  background-color: #eef1f7;
  padding: 2rem;
  margin-bottom: 2rem;
  p {
    margin-bottom: 0;
  }
`;
function Recommandations(props) {
  return React.createElement(Web, {
    title: props.data.mdx.frontmatter.title
  }, React.createElement("section", {
    className: "relative mx-auto flex max-w-sm flex-col px-6 pt-10 md:max-w-6xl xl:pt-20"
  }, React.createElement("h1", {
    className: "max-sm:text-[6.5vw]"
  }, "Nos ", React.createElement("strong", null, "Recommandations")), React.createElement(Introduction, null, props.children), React.createElement(Content, {
    recommandations: props.pageContext.recommandations
  })));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(Recommandations, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const pageQuery = graphql`
  query Recommandations($slug: String!) {
    mdx(fields: { slug: { eq: $slug } }) {
      frontmatter {
        title
      }
    }
  }
`;
